module.exports = __webpack_public_path__ + "static/media/logo.628a5d3d.png";